export default class Site {
  constructor(
    siteNumber = -1,
    siteName = '',
    siteAddress1 = '',
    siteAddress2 = '',
    cityName = '',
    stateAbbr = '',
    zipCode = '',
    countryName = '',
    phone = '',
    siteTypeId = '',
    googleMapsLink = 'https://www.google.com/maps'
  ) {
    this.siteNumber = siteNumber
    this.siteName = siteName
    this.siteAddress1 = siteAddress1
    this.siteAddress2 = siteAddress2
    this.cityName = cityName
    this.stateAbbr = stateAbbr
    this.zipCode = zipCode
    this.countryName = countryName
    this.phone = phone
    this.siteTypeId = siteTypeId
    this.googleMapsLink = googleMapsLink
  }

  mapFromApi(responseData) {
    this.siteNumber = responseData.site_no
    this.siteName = responseData.site_name.trim()
    this.siteAddress1 = responseData.site_addr1.trim()
    this.siteAddress2 = responseData.site_addr2.trim()
    this.cityName = responseData.city_name.trim()
    this.stateAbbr = responseData.state_id.trim()
    this.zipCode =
      responseData.zip_code.length > 5
        ? responseData.zip_code.slice(0, 5) +
          '-' +
          responseData.zip_code.slice(5)
        : responseData.zip_code
    this.countryName = responseData.country_name.trim()
    this.phone =
      responseData.country_name === 'USA' && responseData.phone
        ? responseData.phone.substring(0, 3) +
          '-' +
          responseData.phone.substring(3, 6) +
          '-' +
          responseData.phone.substring(6, responseData.phone.length)
        : responseData.phone
    this.siteTypeId = responseData.sitetype_id.trim()
    this.googleMapsLink =
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURI(
        this.siteAddress1 +
          ' ' +
          this.siteAddress2 +
          ', ' +
          this.cityName +
          ', ' +
          this.stateAbbr +
          ' ' +
          this.zipCode
      )
  }
}
